import { mapActions } from 'vuex'
import Constants from '@/utils/Constants'

export default {
  name: 'MultipleFileInput',
  props: {
    index: {
      type: Number,
      require: false,
      'default': () => 0
    },
    value: {
      type: [File, Object],
      default: null
    },
    showDeleteButton: {
      type: Boolean,
      require: false,
      'default': () => false
    },
    // ファイルタイプ制限
    // pdf: pdf
    // image: jpeg、jpg、png、webp
    // movie: mp4, webm, mov
    // sound: mp3,aac,m4a,ogg
    type: {
      type: String,
      required: false,
      default: '',
    },
    // アップロード可能な最大サイズを指定
    maxSize: {
      type: Number,
      required: false,
      default: Constants.MaxUploadFileSize,
    },
  },
  data() {
    return {
      active: true,
      exp: {
        pdf: ['pdf'],
        image: ['jpeg', 'jpg', 'png', 'webp'],
        movie: ['mp4', 'webm', 'mov'],
        sound: ['mp3', 'aac', 'm4a', 'ogg'],
      },
      message: {
        pdf: 'PDFファイルを選択して下さい。',
        image: '画像ファイル（jpeg/jpg/png/webp）を選択して下さい。',
        movie: '動画ファイル（mp4/webm/mov）を選択して下さい。',
        sound: '音声ファイル（mp3/aac/m4a/ogg）を選択して下さい。',
      }
    }
  },
  computed: {
    fileName () {
      if (!this.value) return '選択されていません'
      return this.value instanceof File ? this.value.name : this.value.fileName
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'alert/show',
    }),

    changeFile (e) {
      if (!e.target.files[0]) return;
      console.log(e.target.files[0])

      // アップロード可能な最大サイズ
      const limit = this.maxSize >= 1000000
        ? this.maxSize / 1000000 + 'M bytes'
        : this.maxSize >= 1000
          ? this.maxSize / 1000 + 'K bytes'
          : this.maxSize + 'bytes';

      // ファイルサイズチェック
      const size = e.target.files[0].size
      if (size > this.maxSize) {
        const body = '選択されたファイルは、' + size.toLocaleString() + 'bytesです。<br>アップロード可能なファイルサイズは、' + limit + 'までです。'
        this.showAlert({
          body: body
        })
        this.reset();
        return;
      }

      // 拡張子チェック
      const array = e.target.files[0].name.split('.');
      const expand = array[array.length - 1].toLowerCase();
      if (this.type === 'pdf' ||
        this.type === 'image' ||
        this.type === 'movie' ||
        this.type === 'sound') {
        if (this.exp[this.type].indexOf(expand) === -1) {
          this.showAlert({
            body: this.message[this.type]
          })
          this.reset();
          return;
        }
      }

      if (expand === 'gif' || expand === 'apng') {
        this.showAlert({
          body: this.message['image']
        })
        this.reset();
        return;
      }

      console.log('emit');
      this.$emit('childs-change', {
        index: this.index,
        file: e.target.files[0]
      })
      // if (size <= Constants.MaxUploadFileSize) {
      //   this.$emit('childs-change', {
      //     index: this.index,
      //     file: e.target.files[0]
      //   })

      // } else {
      //   const body = '選択されたファイルは、' + size.toLocaleString() + 'bytesです。<br>アップロード可能なファイルサイズは、20M bytesまでです。'
      //   this.showAlert({
      //     body: body
      //   })
      // }
    },
    deleteFile () {
      this.$emit('childs-delete', {
        index: this.index
      })
    },
    reset() {
      this.active = false;
      this.$nextTick(() => {
        this.active = true;
      });
    },
  }
}